import React, { useEffect, useState } from 'react';
import './ManageServices.css';

const ManageServices = () => {
    const [services, setServices] = useState([]);

    useEffect(() => {
        fetch('https://serene-beach-92273.herokuapp.com/services')
            .then(res => res.json())
            .then(data => setServices(data));
    }, []);

    return (
        <div className='container my-5'>
            <h2>Manage Services</h2>
            <div className="services">
                {
                    services.map(service => <div className='service-manage'>
                        <h2 className='service-title'>{service.name.toUpperCase()}</h2>
                        <div className="manage-btn">
                            <button className='btn btn-danger btn-sm'>Delete</button>
                            <button className='btn btn-warning btn-sm'>Update</button>
                        </div>
                    </div>)
                }
            </div>
        </div>
    );
};

export default ManageServices;